import Modal from 'components/desktop/shared/modal';
import { IconCheckCircle, IconInformationOutline } from 'components/icons';
import { findIndex, isEqual } from 'lodash';

interface Props {
  type: 'success' | 'error' | 'warning' | 'info';
  title?: string;
  textDescription?: string;
  isHiddenCancelButton?: boolean;
  isHiddenConfirmButton?: boolean;
  cancelText?: string;
  confirmText?: string;
  onClose?: () => void;
  onCancel?: () => void;
  onConfirm?: () => void;
}

const NotificationModal = ({
  type,
  title,
  textDescription,
  isHiddenCancelButton,
  isHiddenConfirmButton,
  cancelText,
  confirmText,
  onCancel,
  onClose,
  onConfirm,
}: Props) => {
  const CancelModal = () => {
    onCancel?.() && onCancel?.();
    onClose?.() && onClose?.();
  };
  const ConfirmModal = () => {
    onConfirm?.() && onConfirm?.();
    onClose?.() && onClose?.();
  };

  const NotificationModalData = [
    {
      id: 1,
      type: 'success',
      icon: <IconCheckCircle className='min-h-[70px] min-w-[70px] text-[#40d124]' />,
      titleColor: 'text-[#22c55e]',
    },
    {
      id: 2,
      type: 'warning',
      icon: <IconInformationOutline className='min-h-[70px] min-w-[70px] text-[#f6c000]' />,
      titleColor: 'text-primary',
    },
    {
      id: 3,
      type: 'error',
      icon: <IconInformationOutline className='min-h-[70px] min-w-[70px] text-alert' />,
      titleColor: 'text-alert',
    },
  ];

  const notificationModalIndex = findIndex(NotificationModalData, (notificationModal) =>
    isEqual(notificationModal?.type, type),
  );

  return !isEqual(notificationModalIndex, -1) ? (
    <Modal className='w-[382px] min-w-[382px]'>
      <div className='flex flex-col items-center space-y-[24px]'>
        <div className='flex flex-col items-center space-y-[16px]'>
          {NotificationModalData?.[notificationModalIndex]?.icon}
          <div className='flex flex-col items-center space-y-[12px] text-center'>
            <span
              className={`text-[18px] leading-[23px] ${NotificationModalData?.[notificationModalIndex]?.titleColor}`}
            >
              {title}
            </span>
            <span className='leading-[18px]'>{textDescription}</span>
          </div>
        </div>
        <div className='flex w-full space-x-[16px]'>
          {!isHiddenCancelButton && (
            <button
              type='button'
              className='flex h-[40px] w-full items-center justify-center rounded-[6px] bg-background p-[12px] transition duration-[200ms] ease-in-out hover:bg-stroke'
              onClick={CancelModal}
            >
              <span className='font-[600]'>{cancelText ? cancelText : 'Hủy'}</span>
            </button>
          )}
          {!isHiddenConfirmButton && (
            <button
              type='button'
              className='h-[40px] w-full items-center justify-center rounded-[6px] bg-primary p-[12px] transition duration-[200ms] ease-in-out hover:bg-primary-light'
              onClick={ConfirmModal}
            >
              <span className='font-[600] text-paper'>
                {confirmText ? confirmText : 'Xác nhận'}
              </span>
            </button>
          )}
        </div>
      </div>
    </Modal>
  ) : null;
};

export default NotificationModal;
